import { render, staticRenderFns } from "./VFair.vue?vue&type=template&id=352645e5&scoped=true&"
import script from "./VFair.vue?vue&type=script&lang=js&"
export * from "./VFair.vue?vue&type=script&lang=js&"
import style0 from "./VFair.vue?vue&type=style&index=0&id=352645e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352645e5",
  null
  
)

export default component.exports